"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sweetalert2_1 = __importDefault(require("sweetalert2"));
class Alerts {
    constructor(title) {
        this.title = '';
        this.description = '';
        this.icon = 'success';
        this.confirmButtonText = 'close';
        this.denyButtonText = '';
        this.showCancelButton = true;
        this.title = title ? title : this.title;
    }
    withOutCloseBtn() {
        this.showCancelButton = false;
        return this;
    }
    asInfo() {
        this.icon = 'info';
        return this;
    }
    withTitle(title) {
        this.title = title;
        return this;
    }
    reset() {
        this.denyButtonText = '';
        this.showCancelButton = true;
        this.showCancelButton = true;
        this.confirmButtonText = 'Ok';
    }
    success(description, confirmButtonText) {
        this.reset();
        this.icon = 'success';
        this.title = description;
        this.confirmButtonText = confirmButtonText
            ? confirmButtonText : this.confirmButtonText;
        this.showAlert();
    }
    error(description, confirmButtonText) {
        this.reset();
        this.icon = 'error';
        this.confirmButtonText = confirmButtonText
            ? confirmButtonText : this.confirmButtonText;
        this.title = description;
        this.showAlert();
    }
    info(description, confirmButtonText) {
        this.reset();
        this.icon = 'info';
        this.title = description;
        this.confirmButtonText = confirmButtonText
            ? confirmButtonText : this.confirmButtonText;
        this.showAlert();
    }
    confirm(question, confirmButtonText, denyButtonText, confirmAction, denyAction) {
        this.reset();
        this.title = question;
        this.confirmButtonText = confirmButtonText;
        this.denyButtonText = denyButtonText;
        this.showAlert().then((result) => {
            console.log(result);
            if (result.isConfirmed) {
                confirmAction();
            }
            else if (result.isDenied) {
                denyAction();
            }
        });
    }
    showAlert() {
        let obj = {
            title: this.title,
            text: this.description,
            showCancelButton: true,
            icon: this.icon,
            confirmButtonText: this.confirmButtonText,
            denyButtonText: this.denyButtonText
        };
        if (this.denyButtonText !== '') {
            obj = Object.assign(Object.assign({}, obj), { showDenyButton: true });
            // @ts-ignore
            delete obj['showCancelButton'];
        }
        if (!this.showCancelButton) {
            // @ts-ignore
            delete obj['showCancelButton'];
        }
        // @ts-ignore
        return sweetalert2_1.default.fire(obj);
    }
}
exports.default = Alerts;
